/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commonlocked1Inputs */



/**
* | output |
* | --- |
* | "Unavailable" |
*
* @param {Commonlocked1Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const commonlocked1 = /** @type {((inputs?: Commonlocked1Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commonlocked1Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Unavailable")
	if (locale === "es") return /** @type {LocalizedString} */ ("No disponible")
	return /** @type {LocalizedString} */ ("Недоступно")
});
export { commonlocked1 as "commonLocked" }